import { MaskCard } from '@/types/mask-card.type';

/** Characteristic frame palettes: 12 colors each, left-to-right by rows from reference boards. */
export const colorCards: MaskCard[] = [
  {
    id: 1,
    type: 'cold',
    segments: [
      { color: '#2B6D7B' },
      { color: '#9ABCBD' },
      { color: '#FFC1EA' },
      { color: '#DB5793' },
      { color: '#842E53' },
      { color: '#4CB5D3' },
      { color: '#21418E' },
      { color: '#F4EC7D' },
      { color: '#23ADB7' },
      { color: '#19897D' },
      { color: '#F65D8C' },
      { color: '#7B3569' },
    ],
  },
  {
    id: 2,
    type: 'warm',
    segments: [
      { color: '#EBD7B2' },
      { color: '#FFA18B' },
      { color: '#AFC547' },
      { color: '#C05241' },
      { color: '#F37658' },
      { color: '#FBD5A6' },
      { color: '#F0AF53' },
      { color: '#ADA14B' },
      { color: '#745539' },
      { color: '#E34D4E' },
      { color: '#F5CC72' },
      { color: '#E18753' },
    ],
  },
  {
    id: 3,
    type: 'dark',
    segments: [
      { color: '#6D282D' },
      { color: '#2F253D' },
      { color: '#B78B5A' },
      { color: '#1E413B' },
      { color: '#973D59' },
      { color: '#4B2125' },
      { color: '#EED8A6' },
      { color: '#127685' },
      { color: '#263556' },
      { color: '#F17688' },
      { color: '#2F3529' },
      { color: '#8C857D' },
    ],
  },
  {
    id: 4,
    type: 'light',
    segments: [
      { color: '#F2ECD6' },
      { color: '#79DDBB' },
      { color: '#B8DB99' },
      { color: '#FDD08D' },
      { color: '#6989C6' },
      { color: '#F0AAB4' },
      { color: '#6FC7DD' },
      { color: '#F2D9B0' },
      { color: '#F8778D' },
      { color: '#F3BB9A' },
      { color: '#B0A7D2' },
      { color: '#F79F6F' },
    ],
  },
  {
    id: 5,
    type: 'mute',
    segments: [
      { color: '#B07081' },
      { color: '#DEA4A0' },
      { color: '#527A93' },
      { color: '#C5A771' },
      { color: '#6F5944' },
      { color: '#AFA794' },
      { color: '#578E8B' },
      { color: '#E5D99F' },
      { color: '#807D92' },
      { color: '#55608D' },
      { color: '#98795D' },
      { color: '#83926B' },
    ],
  },
  {
    id: 6,
    type: 'bright',
    segments: [
      { color: '#8DBC48' },
      { color: '#FB7B62' },
      { color: '#D3363F' },
      { color: '#EC488F' },
      { color: '#604D9C' },
      { color: '#4FD3DF' },
      { color: '#1070BA' },
      { color: '#FBC56B' },
      { color: '#202020' },
      { color: '#D6D2ED' },
      { color: '#14914F' },
      { color: '#E54E6F' },
    ],
  },
];
